import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Popover, Tooltip } from 'react-bootstrap';
import { AsyncTypeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import PropTypes from 'prop-types';
import Timestamp from './Timestamp';
import NavigationBar from './NavigationBar';
import Octicon, {Organization} from '@githubprimer/octicons-react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead-bs4.css';
import { fetchActiveTournament } from '../actions';
import TournamentInfo from './TournamentInfo';

class RegistrationPage extends Component {

  confirmationTypes = {
    'NONE': 'Bez potwierdzenia',
    'EMAIL': 'Potwierdzenie na e-mail',
    'SMS': 'Potwierdzenie SMS'
  }

  constructor() {
    super();
    this.register = this.register.bind(this);
    this.updateRegistration = this.updateRegistration.bind(this);
    this.deleteRegistration = this.deleteRegistration.bind(this);
    this.onAccessCodeUpdate = this.onAccessCodeUpdate.bind(this);
    this.verifyAccessCode = this.verifyAccessCode.bind(this);
    this.setConfirmationType = this.setConfirmationType.bind(this);
    this.updateConfirmationTarget = this.updateConfirmationTarget.bind(this);
    this.updateName = this.updateName.bind(this);
    this.pay = this.pay.bind(this);
    this.state = { selected: [], playerHints: [], registered: false, isLoading: false, confirmationType: 'NONE' };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    if (!this.tournament()) {
      dispatch(fetchActiveTournament(this.tournamentId()));
    }
  }

  tournamentId() {
    return this.props.match.params.id;
  }

  action() {
    return this.props.match.params.action;
  }

  tournament() {
    return this.props.tournaments.find(tournament => tournament.id == this.tournamentId());
  }

  emptyPlayersArray(tournament) {
    const emptyPlayersList = [];
      for (var i = 0; i < tournament.minPlayers; i++) {
        emptyPlayersList.push({associated: true});
      }
    return emptyPlayersList;
  }

  playersArray() {
    const tournament = this.tournament();

    if (this.state.players) {
      return this.state.players;
    } else if (tournament) {
      return this.emptyPlayersArray(tournament);
    } else {
      return [];
    }
  }

  render() {
    const action = this.action();

    if (!this.tournament()) {
      return (<div></div>);
    } else if (action === 'register' && this.state.registered) {
      return this.registrationConfirmation();
    } else if (action === 'update' && this.state.updated) {
      return this.updateConfirmation();
    } else if (action === 'update' && this.state.deleted) {
      return this.deletionConfirmation();
    } else {
      return this.registerForm();
    }
  }

  registrationConfirmation() {
    const tournament = this.tournament();
    return (
      <div>
        <NavigationBar />
        <div className="container tournament-tile-container">
          <TournamentInfo tournament={tournament} />
          <div className="alert alert-info">
            <div className="mt-1 mb-1">Zostałeś zarejestrowany.</div>
            <div className="mt-2 mb-2">
              Kod Twojej rejestracji to <code className="d-inline-block card pl-1 pr-1">{this.state.accessCode}</code>.<br />
              Zapisz go, aby móc zmienić lub wycofać rejestrację.<br />
            </div>
            <div className="mt-1 mb-1">
              { this.postRegistrationInstructions() }
            </div>
          </div>
        </div>
      </div>
    );
  }

  postRegistrationInstructions() {
    const tournament = this.tournament();

    if (tournament.pricing) {
      return (<span><b><Link to={`/tournaments/${tournament.id}/pay`} className="text-danger">Zapłać wpisowe</Link></b> przez internet lub <b><Link to="/">wróć</Link></b> do listy turniejów.</span>);
    } else {
      return (<span><b><Link to="/">Wróć</Link></b> do listy turniejów.</span>);
    }
  }

  updateConfirmation() {
    const tournament = this.tournament();
    return (
      <div>
        <NavigationBar />
        <div className="container tournament-tile-container">
          <TournamentInfo tournament={tournament} />
          <div className="alert alert-info">
            <div className="mt-1 mb-1">Zmiany w rejestracji zostały wprowadzone.</div>
            <div className="mt-1 mb-1">
              Kliknij <b><Link to="/">tutaj</Link></b>, aby wrócić do listy turniejów.
            </div>
          </div>
        </div>
      </div>
    );
  }

  deletionConfirmation() {
    const tournament = this.tournament();
    return (
      <div>
        <NavigationBar />
        <div className="container tournament-tile-container">
          <TournamentInfo tournament={tournament} />
          <div className="alert alert-info">
            <div className="mt-1 mb-1">Rejestracja została odwołana.</div>
            <div className="mt-1 mb-1">
              Kliknij <b><Link to="/">tutaj</Link></b>, aby wrócić do listy turniejów.
            </div>
          </div>
        </div>
      </div>
    );
  }

  registerForm() {
    const { t } = this.props;
    const tournament = this.tournament();
    const action = this.action();

    const maxNumberOfParticipants = tournament.maxPlayers;

    const registrationActionButtons = [];

    const players = this.playersArray();

    if (players.length < maxNumberOfParticipants) {
      registrationActionButtons.push(
        <button className="btn btn-secondary mr-2 registration-action-button" onClick={this.addPlayer()} key="addPlayerButton">
          Dodaj zawodnika
        </button>
      );
    }

    registrationActionButtons.push(
      <button type="button" className="btn btn-primary mr-2 registration-action-button" onClick={this.register} key="registerButton">
        { t('tournamentList.confirmRegistration') }
      </button>
    );

    return (
      <div>
        <NavigationBar />
        <div className="container tournament-tile-container">
          <TournamentInfo tournament={tournament} />
          {this.errorBlock()}
          <div className="registration-buttons-row" style={ action === 'info' ? {} : { display: 'none' } }>
            <Link to={`/tournaments/${tournament.id}/register`}>
              <button type="button" className="btn btn-primary ml-2 mr-2 registration-action-button" key="showRegistrationDialogButton">
                { t('tournamentList.register') }
              </button>
            </Link>
            <Link to={`/tournaments/${tournament.id}/update`}>
              <button type="button" className="btn btn-secondary ml-2 mr-2 registration-action-button" key="showChangeRegistrationDialogButton">
                { t('tournamentList.changeRegistration') }
              </button>
            </Link>
          </div>
          <div className="col-md-9 card" style={ action === 'register' ? {} : { display: 'none' } }>
            <h3 className="mt-3 mb-3">Rejestracja</h3>
            <div className="input-group mb-2 mr-sm-2" style={ tournament.type === 'TEAMS' ? {} : { display: 'none' } }>
              <div className="input-group-prepend">
                <div className="input-group-text">Nazwa teamu</div>
              </div>
              <input type="text" class="form-control" value={this.state.name} onChange={this.updateName()} />
            </div>
            {this.createTable()}
            <div className="input-group mt-3 mb-3 ml-2 mr-2">
              <div className="input-group-prepend">
                <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {this.confirmationTypes[this.state.confirmationType]}
                </button>
                <div className="dropdown-menu">
                  {
                    Object.keys(this.confirmationTypes).map(confType =>
                      <button className="dropdown-item" onClick={this.setConfirmationType(confType)}>{this.confirmationTypes[confType]}</button>
                    )
                  }
                </div>
              </div>
              {
                this.state.confirmationType !== 'NONE' ?
                  <input
                    type={this.state.confirmationType === 'EMAIL' ? 'email' : 'tel'}
                    className={"form-control col-md-4 " + (this.validationClass('email') || this.validationClass('phoneNumber'))}
                    value={this.state.confirmationTarget}
                    onChange={this.updateConfirmationTarget()} /> :
                  ''
              }
            </div>
            <div className="mb-3">{registrationActionButtons}</div>
          </div>
          <div className="col-md-9 card" style={ action === 'update' ? {} : { display: 'none' } }>
            <h3 className="mb-3 mt-3">Zmiana rejestracji</h3>
            {this.changeRegistrationPanel()}
          </div>
          <div className="col-md-9 card" style={ action === 'pay' ? {} : { display: 'none' } }>
            <h3 className="mb-3 mt-3">Zapłać wpisowe</h3>
            {this.paymentPanel()}
          </div>
        </div>
      </div>
    );
  }

  isInvalid(fieldName) {
    return this.state.invalidFields && this.state.invalidFields.includes(fieldName);
  }

  validationClass(fieldName) {
    if (this.isInvalid(fieldName)) {
      return 'is-invalid';
    } else {
      return '';
    }
  }

  setConfirmationType(confType) {
    return (evt) => {
      const confirmationTarget = confType === 'None' ? undefined : '';
      this.setState({confirmationType: confType, confirmationTarget: confirmationTarget});
    };
  }

  updateConfirmationTarget() {
    return (evt) => {
      this.setState({confirmationTarget: evt.target.value});
    };
  }

  updateName() {
    return (evt) => {
      this.setState({name: evt.target.value});
    };
  }

  errorBlock() {
    if (this.state.error) {
      return (
        <div className="inline-block alert alert-danger">
            {this.state.error}
        </div>
      );
    } else {
      return (<div></div>);
    }
  };

  changeRegistrationPanel() {
    const { t } = this.props;
    const tournament = this.tournament();

    return (
      <div className="mb-3">
        <form className="mb-3 ml-3 mr-3">
          <div className="input-group col-md-6 mt-2 mb-2">
            <div className="input-group-prepend">
              <div className="input-group-text">Kod dostępu</div>
            </div>
            <input type="text" value={this.state.accessCodeInput} onChange={this.onAccessCodeUpdate()} className="form-control" />
            <button className="btn btn-primary ml-2 mr-2" onClick={this.verifyAccessCode}>OK</button>
          </div>
          { this.state.paymentStatus ?
            (<div className="alert alert-info">{t('registrationPage.paymentStatus.' + this.state.paymentStatus)}</div>) : ''
          }
          <div className="input-group mb-2 mr-sm-2" style={ tournament.type === 'TEAMS' && this.state.name ? {} : { display: 'none' } }>
              <div className="input-group-prepend">
                <div className="input-group-text">Nazwa teamu</div>
              </div>
              <input type="text" class="form-control" value={this.state.name} onChange={this.updateName()} />
          </div>
          <div>
            { this.state.players ? this.createTable() : '' }
          </div>
          <div className="float-right" style={ this.state.players && this.state.deleteAllowed ? {} : {display: 'none'} }>
            <button className="btn btn-danger ml-2 mr-2" data-toggle="modal" data-target="#cancelRegistrationModal">Odwołaj rejestrację</button>
          </div>
          <div className="input-group col-md-6 mt-2 mb-2" style={ this.state.players ? {} : {display: 'none'} }>
            <button className="btn btn-primary mr-2" onClick={this.updateRegistration} style={ this.state.updateAllowed ? {} : {display: 'none'} }>Zapisz zmiany</button>
            { tournament.pricing && this.state.paymentAllowed ?
              <Link to={`/tournaments/${tournament.id}/pay`}><button className="btn btn-secondary mr-2">Zapłać wpisowe</button></Link> : ''
            }
            {
              this.state.paymentStatus === 'PENDING' && this.state.paymentUrl ?
              <a role="button" href={`${this.state.paymentUrl}`} className="btn btn-primary mr-2">Przejdź do płatności</a> : ''
            }
          </div>
        </form>
        <div className="modal fade" id="cancelRegistrationModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Potwierdzenie</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <span>Czy na pewno chcesz odwołać rejestrację?</span>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-dismiss="modal">Nie</button>
                  <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.deleteRegistration}>Tak</button>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }

  paymentPanel() {
    const table = [];
    const players = this.playersArray();
    const tournament = this.tournament();

    for (let i = 0; i < players.length; i++) {
      const player = players[i];

      table.push(
        <tr>
          <td>{i + 1}</td>
          <td>{player.id}</td>
          <td>{player.name}</td>
          <td>{player.surname}</td>
          { tournament.pricing && tournament.pricing.type === 'PLAYER' ? (<td>{player.price} zł</td>) : '' }
        </tr>
      );
    }

    return (
      <div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Imię</th>
              <th>Nazwisko</th>
              { tournament.pricing && tournament.pricing.type === 'PLAYER' ? (<th>Wpisowe</th>) : '' }
            </tr>
          </thead>
          <tbody>
            {table}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={tournament.pricing && tournament.pricing.type === 'PLAYER' ? 4 : 3} className="text-right"><b>SUMA</b></td>
              <td>{this.state.totalPrice} zł</td>
            </tr>
          </tfoot>
        </table>
        <div className="col-md-6 mt-2 mb-2">
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon1">e-mail</span>
            </div>
            <input
              type="text"
              className={ "form-control " + this.validationClass('email') }
              value={this.state.paymentEmail}
              onChange={this.onPaymentEmailChange()} />
          </div>
          <button className="btn btn-primary mr-2" onClick={this.pay}>Płacę z PayU</button>
        </div>
      </div>
    );
  }

  onPaymentEmailChange() {
    return (evt) => {
      this.setState({ paymentEmail: evt.target.value });
    };
  }

  pay() {
    const { t } = this.props;

    const tournament = this.tournament();
    fetch(
      `/api/tournaments/${tournament.id}/participant/payment`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          accessCode: this.state.accessCodeInput,
          email: this.state.paymentEmail
        })
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(data => {
          location.href = data.paymentProviderUrl;
        });
      } else {
        response.json().then(data => {
          this.setState({
            error: t('tournamentList.errors.' + data.message),
            invalidFields: data.errors
          });
        });
      }
    });
  }

  onAccessCodeUpdate() {
    return (evt) => {
      this.setState({ accessCodeInput: evt.target.value });
    };
  }

  verifyAccessCode() {
    const tournament = this.tournament();
    fetch(`/api/tournaments/${tournament.id}/participant?accessCode=${this.state.accessCodeInput}`).then(response => {
        if (response.status === 200) {
          response.json().then(data => {
            const playersList = data.players.map(player => ({...player, associated: true}));
            this.setState({
              selected: playersList,
              name: data.name,
              players: playersList,
              totalPrice: data.totalPrice,
              paymentStatus: data.paymentStatus,
              paymentUrl: data.paymentUrl,
              paymentEmail: data.email,
              updateAllowed: data.updateAllowed,
              deleteAllowed: data.deleteAllowed,
              paymentAllowed: data.paymentAllowed
            });
          });
        } else {
          response.json().then(data => this.setState({ error: t('tournamentList.errors.' + data.message)}));
        }
      });
  }

  createTable() {
    const table = [];
    const players = this.playersArray();

    for (let i = 0; i < players.length; i++) {
      const player = players[i];

      const registrationTypeLabel = player.associated ? 'członek PZBS' : 'niezrzeszony';

      table.push(
        <div className="registration-row mt-1 mb-1" key={i.toString()}>
          <div className="dropdown inline-block registration-data-type-selector">
            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {registrationTypeLabel}
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button className="dropdown-item" onClick={this.onAssociatedPlayer(i)}>członek PZBS</button>
              <button className="dropdown-item" onClick={this.onNonAssociatedPlayer(i)}>niezrzeszony</button>
            </div>
          </div>
          {this.playerInput(player, i)}
          {this.associatedPlayerInfo(player)}
        </div>
      );
    }

    return table;
  }

  playerInput(player, playerIdx) {
    let registrationDataSource = undefined;

    if (player.associated) {
      registrationDataSource = player.id;
    } else if (player.name && player.surname) {
      registrationDataSource = player.name + ' ' + player.surname;
    } else {
      registrationDataSource = player.name;
    }

    const registrationDataPlaceholder = player.associated ? 'Podaj ID lub szukaj po nazwisku...' : 'Podaj imię i nazwisko...';

    if (player.associated) {
      const selectedItem = this.state.selected[playerIdx];

      return (
        <div className="inline-block registration-data-input col-md-6">
          <AsyncTypeahead
            isInvalid={this.isInvalid('players[' + playerIdx.toString() + ']')}
            selected={selectedItem !== undefined ? [selectedItem] : selectedItem}
            isLoading={this.state.isLoading}
            labelKey={player => `${player.name} ${player.surname}`}
            filterBy={['id']}
            renderMenu={(results, menuProps) => (
              <Menu {...menuProps}>
                {results.map((result, index) => (
                  <MenuItem option={result} position={index}>
                    {result.name} {result.surname}, ID {result.id}, {result.location}, {result.rank}
                  </MenuItem>
                ))}
              </Menu>
            )}
            options={this.state.playerHints}
            placeholder={registrationDataPlaceholder}
            value={registrationDataSource}
            onChange={this.onPlayerChange(playerIdx)}
            onSearch={query => {
              this.setState({isLoading: true});
              fetch(`/api/players/hint?searchString=${query}`)
                .then(resp => resp.json())
                .then(json => {
                  this.setState({
                    isLoading: false,
                    playerHints: json
                  });
                });
            }}
            />
        </div>
      );
    } else {
      return (
        <div className="inline-block registration-data-input col-md-6">
          <input
            type="text"
            className={"form-control " + this.validationClass('players[' + playerIdx.toString() + ']')}
            placeholder={registrationDataPlaceholder}
            value={registrationDataSource}
            onChange={this.onNameChange(playerIdx)} />
        </div>
      );
    }
  }

  associatedPlayerInfo(player) {
    if (player.id) {
      return (<div className="inline-block text-muted">ID {player.id}, Okręg {player.location}, WK {player.rank}</div>);
    } else {
      return (<div></div>);
    }
  }

  onPlayerChange(playerIdx) {

    return (players) => {
      const updatedPlayer = players[0];
      const updatedSelection = this.state.selected.slice();
      updatedSelection[playerIdx] = updatedPlayer;

      const updatedPlayers = this.playersArray().map((player, idx) => {
        if (idx !== playerIdx) {
          return player;
        } else {
          return {...updatedPlayer, associated: true};
        }
      });
      this.setState({ selected: updatedSelection, players: updatedPlayers });
    };
  }

  onNameChange(playerIdx) {
    return (evt) => {
      const updatedPlayerName = evt.target.value;
      const updatedPlayers = this.playersArray().map((player, idx) => {
        if (idx !== playerIdx) return player;
        return {...player, name: updatedPlayerName};
      });
      this.setState({ players: updatedPlayers });
    };
  }

  onAssociatedPlayer(playerIdx) {
    return (evt) => {
      const updatedPlayers = this.playersArray().map((player, idx) => {
        if (idx !== playerIdx) return player;
        return {...player, associated: true, id: undefined, name: undefined };
      });
      this.setState({ players: updatedPlayers });
    };
  }

  onNonAssociatedPlayer(playerIdx) {
    return (evt) => {
      const updatedPlayers = this.playersArray().map((player, idx) => {
        if (idx !== playerIdx) return player;
        return {...player, associated: false, id: undefined, name: undefined, surname: undefined };
      });
      this.setState({ players: updatedPlayers });
    };
  }

  addPlayer() {
    return (evt) => {
      this.setState({ players: this.playersArray().concat([{associated: true}]) });
    };
  }

  register() {
    const { t } = this.props;
    const tournament = this.tournament();

    const registrationData = {
      name: this.state.name,
      players: this.playersArray().map(this.playerToDto)
    };

    if (this.state.confirmationType === 'EMAIL') {
      registrationData['email'] = this.state.confirmationTarget;
    } else if (this.state.confirmationType === 'SMS') {
      registrationData['phoneNumber'] = this.state.confirmationTarget;
    }

    fetch(
      `/api/tournaments/${tournament.id}/participants`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(registrationData)
      }).then(response => {
        if (response.status === 200) {
          response.json().then(data => {
            const playersList = data.players.map(player => ({...player, associated: true}));
            this.setState({
              registered: tournament.paymentMode !== 'MANDATORY',
              error: undefined,
              invalidFields: undefined,
              name: data.name,
              selected: playersList,
              players: playersList,
              totalPrice: data.totalPrice,
              accessCode: data.accessCode,
              accessCodeInput: data.accessCode,
              paymentEmail: data.email,
              paymentStatus: data.paymentStatus,
              paymentUrl: data.paymentUrl,
              updateAllowed: data.updateAllowed,
              deleteAllowed: data.deleteAllowed,
              paymentAllowed: data.paymentAllowed
            });
            location.href = `#/tournaments/${tournament.id}/pay`;
          });
        } else {
          response.json().then(data => this.setState({
            error: t('tournamentList.errors.' + data.message),
            invalidFields: data.errors
          }));
        }
      });
  }

  updateRegistration() {
    const { t } = this.props;
    const tournament = this.tournament();

    fetch(
      `/api/tournaments/${tournament.id}/participant?accessCode=${this.state.accessCodeInput}`,
      {
        method: 'PUT',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          name: this.state.name,
          players: this.playersArray().map(this.playerToDto)
        })
      }).then(response => {
        if (response.status === 200) {
          this.setState({ updated: true, error: undefined });
        } else {
          response.json().then(data => this.setState({ error: t('tournamentList.errors.' + data.message)}));
        }
      });
  }

  deleteRegistration() {
    const { t } = this.props;
    const tournament = this.tournament();

    fetch(
      `/api/tournaments/${tournament.id}/participant?accessCode=${this.state.accessCodeInput}`,
      {
        method: 'DELETE'
      }).then(response => {
        if (response.status === 200) {
          this.setState({ deleted: true, error: undefined });
        } else {
          response.json().then(data => this.setState({ error: t('tournamentList.errors.' + data.message)}));
        }
      });
  }

  playerToDto(player) {
    if (player.associated) {
      return {
        id: parseInt(player.id, 10)
      };
    } else {
      const nameTokens = player.name ? player.name.trim().replace(/ +/g, ' ').split(' '): ['', ''];
      return {
        name: nameTokens.slice(0, nameTokens.length - 1).join(' ').trim(),
        surname: nameTokens[nameTokens.length - 1].trim()
      };
    }
  }
}

RegistrationPage.propTypes = {
  tournaments: PropTypes.arrayOf(PropTypes.object),
  dispatch: PropTypes.func.isRequired
};


function mapStateToProps(state) {
  return { tournaments: state.tournaments };
}

export default translate('translations')(connect(mapStateToProps)(RegistrationPage));



// WEBPACK FOOTER //
// ./components/RegistrationPage.js